// Définition des couleurs principales pour le dashboard
export const colors = {
  primary: '#FF6B00',
  primaryLight: '#FFF0E6',
  primaryDark: '#D95A00',
  secondary: '#437011',
  secondaryLight: '#F4F8E9',
  secondaryDark: '#365D0E',
  info: '#2563EB',
  infoLight: '#EFF6FF',
  success: '#10B981',
  successLight: '#D1FAE5',
  gradient: {
    orange: 'linear-gradient(135deg, #FF6B00 0%, #FF9248 100%)',
    green: 'linear-gradient(135deg, #437011 0%, #5C9A18 100%)',
    blue: 'linear-gradient(135deg, #2563EB 0%, #60A5FA 100%)',
    purple: 'linear-gradient(135deg, #8B5CF6 0%, #A78BFA 100%)',
    pink: 'linear-gradient(135deg, #EC4899 0%, #F472B6 100%)',
  }
};

// Fonction pour générer une couleur basée sur les initiales
export const getInitialsColor = (initials) => {
  const charCodeSum = initials.charCodeAt(0) + (initials.length > 1 ? initials.charCodeAt(1) : 0);
  const colorIndices = [
    'linear-gradient(135deg, #FF6B00 0%, #FF9248 100%)',
    'linear-gradient(135deg, #437011 0%, #5C9A18 100%)',
    'linear-gradient(135deg, #2563EB 0%, #60A5FA 100%)',
    'linear-gradient(135deg, #8B5CF6 0%, #A78BFA 100%)',
    'linear-gradient(135deg, #EC4899 0%, #F472B6 100%)',
  ];
  
  return colorIndices[charCodeSum % colorIndices.length];
};
